import styled from 'styled-components';
import NavLink from '../link';

const StyledNavLink = styled(NavLink).attrs({ state: { via: 'CoverNavLink' } })`
  display: flex;
  gap: 0.3rem;
  color: white;
  font-weight: 700;
  padding: 1.25rem ${({ theme }) => theme.grid.containerGap};
  border-top: 1px solid ${({ theme }) => theme.grayDarkColor};
  width: 100%;

  &:is(a):hover,
  &.${({ activeClassName }) => activeClassName} {
    color: ${({ theme }) => theme.fontColor};
    background-color: ${({ theme }) => theme.primaryColor};
  }
`;

export default StyledNavLink;
